import type { Nullable } from '@synqo/frontend-component-library';
import type { BaseKeyword } from './keywords';

export const controlTypes = ['offset'] as const;
export type ControlType = (typeof controlTypes)[number];

const keywordControlMap: Record<BaseKeyword, ControlType> = {
    x_offset: 'offset',
    y_offset: 'offset',
};

export const getControlTypeByKeyword = (keyword: BaseKeyword): Nullable<ControlType> =>
    keywordControlMap[keyword] ?? null;
